import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

import TunnelDetailPage from '@/screens/settings/on-premise/id/page';

export const Route = createFileRoute('/_app/settings/on-premise/$id/')({
  component: TunnelDetailRoute,
});

function LoadingFallback() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}

function TunnelDetailRoute() {
  const { id } = Route.useParams();
  return (
    <Suspense fallback={<LoadingFallback />}>
      <TunnelDetailPage tunnelId={id} />
    </Suspense>
  );
}
